// Debug utilities for token-related logging
// Logs only when REACT_APP_NODE_ENV=development

export const isDev = (() => {
  try {
    const env = ((process.env && (process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV)) || '').toLowerCase();
    return env === 'development';
  } catch (_) {
    return false;
  }
})();

function ts() {
  try {
    return new Date().toISOString();
  } catch (_) {
    return '';
  }
}

function prefix(source) {
  return `[${source}][${ts()}]`;
}

function normalizeArgs(args) {
  return args.map(a => a);
}

export function logWithSource(source, level, ...args) {
  if (!isDev) return;
  const p = prefix(source || 'App');
  const items = normalizeArgs(args);
  try {
    if (level === 'error') console.error(p, ...items);
    else if (level === 'warn') console.warn(p, ...items);
    else if (level === 'debug') console.debug(p, ...items);
    else console.log(p, ...items);
  } catch (_) {}
}

export function createLogger(source) {
  const s = source || 'App';
  return {
    log: (...a) => logWithSource(s, 'log', ...a),
    info: (...a) => logWithSource(s, 'log', ...a),
    debug: (...a) => logWithSource(s, 'debug', ...a),
    warn: (...a) => logWithSource(s, 'warn', ...a),
    error: (...a) => logWithSource(s, 'error', ...a)
  };
}

export function tokenLog(...args) { logWithSource('Token', 'log', ...args); }
export function tokenWarn(...args) { logWithSource('Token', 'warn', ...args); }
export function tokenError(...args) { logWithSource('Token', 'error', ...args); }
export function tokenDebug(...args) { logWithSource('Token', 'debug', ...args); }


